const defaultOptions = {
  disLinkable: true, // 可删除连线
  linkable: true, // 可连线
  draggable: true, // 可拖动
  zoomable: true, // 可放大
  moveable: true, // 可平移
  theme: {
    edge: {
      arrow: true,
      shapeType: 'Straight',
    }
  }
};
  
export {
  defaultOptions,
};
